module.exports = __webpack_public_path__ + "img/keyboard_I.19fd8c5d.png";